import { useCallback } from 'react';
import { useNotifier } from '@provider/notifier';
import { ResultsDialogGraphic } from '@ui/kit/icons';
import { useOpgavekompleksetComponent } from '../context.data.js';
import { useOpgavekompleksetEntry } from '../hook.entry.js';
import { useFinishEntryMutation } from '../mutations/finish.js';
import { makeSelectHasUninteractedTasks } from '../selectors/entry.has-uninteracted-tasks.js';
import { heading } from './shared.modal.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

/**
 * NB: In case there are unasnwered tasks, then a modal will be displayed
 * before completing the action. If all tasks have been answered, then the
 * action will be immediate.
 */
function useFinishAction(args) {
  const notifier = useNotifier();
  const component = useOpgavekompleksetComponent();
  const hasUninteractedTasks = useOpgavekompleksetEntry({
    select: makeSelectHasUninteractedTasks(component.data)
  });
  const finishMutation = useFinishEntryMutation();
  return useCallback(async () => {
    const showModal = hasUninteractedTasks && !args?.skipModal;
    if (showModal) {
      const modalRes = await notifier.confirm(finishEntryModalConfig);
      if (modalRes !== "ok") {
        return;
      }
    }
    finishMutation();
  }, [args?.skipModal, finishMutation, hasUninteractedTasks, notifier]);
}
const finishEntryModalConfig = {
  heading: /*#__PURE__*/jsxs("span", {
    className: heading,
    children: [/*#__PURE__*/jsx(ResultsDialogGraphic, {
      role: "presentation"
    }), /*#__PURE__*/jsx("span", {
      children: "Vil du afslutte og se dine resultater?"
    })]
  }),
  body: /*#__PURE__*/jsx(Fragment, {}),
  labels: {
    ok: "Ja, vis mig resultater",
    cancel: "Nej, tilbage til opgaven"
  }
};

export { finishEntryModalConfig, useFinishAction };
//# sourceMappingURL=finish.js.map
